import React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/lib/auth";
import { GraduationCap, Calendar, Award, TrendingUp } from "lucide-react";

export default function EmployeePortal() {
  const { user } = useAuth();
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-1">Employee Portal</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Hi {user?.name?.split(" ")[0]} — your growth in one place.</h1>
      </div>
      <div className="grid md:grid-cols-4 gap-0 border border-border rounded-lg overflow-hidden bg-white">
        {[
          { icon: Calendar, label: "PTO Balance", v: "14 days" },
          { icon: Award, label: "Certifications", v: "3" },
          { icon: GraduationCap, label: "Courses in progress", v: "2" },
          { icon: TrendingUp, label: "Skill score", v: "78 / 100" },
        ].map((k, i) => {
          const Icon = k.icon;
          return (
            <div key={i} className={`p-6 ${i < 3 ? "md:border-r border-border" : ""}`}>
              <Icon className="h-5 w-5 text-[#0047AB] mb-3" strokeWidth={1.5} />
              <div className="font-display text-2xl font-bold tracking-tight">{k.v}</div>
              <div className="text-xs uppercase tracking-widest text-muted-foreground mt-1">{k.label}</div>
            </div>
          );
        })}
      </div>
      <Card className="border-border shadow-none p-6">
        <h3 className="font-display text-lg font-bold tracking-tight">Recommended for you</h3>
        <p className="text-sm text-muted-foreground mt-1">Based on your skill graph and role trajectory.</p>
        <div className="mt-4 space-y-2">
          {[
            "Structured Interviewing at Scale · 4h",
            "Human-in-the-Loop Decision Making · 2h",
            "Bias Detection in AI Recommendations · 2h",
          ].map((c) => (
            <div key={c} className="p-3 border border-border rounded-md flex items-center justify-between hover:border-[#0047AB]">
              <div className="text-sm font-medium">{c}</div>
              <Badge variant="outline" className="text-[10px] font-mono uppercase tracking-wider">Enroll</Badge>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
